package com.tregz.tremenz.ui.theme

import androidx.compose.material3.ColorScheme
import androidx.compose.runtime.Composable

/** Browsers expose no wallpaper palette, so the bundled schemes always apply. */
@Composable
actual fun dynamicColorScheme(darkTheme: Boolean): ColorScheme? = null
